<template>
  <div>
    <multiselect
      class="float-left"
      v-model="selecionado"
      :disabled="disabled"
      :options="options"
      v-bind="atributos"
      @input="atualizarValor"
    >
    </multiselect>
    <a
      v-if="temLimpar"
      :disabled="disabled"
      href="javascript:void(0)"
      class="text-gray d-flex single-select"
      @click="atualizarValor(null)"
    >
      <i class="fas fa-times" />
    </a>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "Select",
  components: {
    Multiselect
  },
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    value: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    autoSelect: {
      type: Boolean,
      default: false
    },
    limpar: {
      type: Boolean,
      default: true
    }
  },
  data,
  computed: {
    atributos,
    temLimpar
  },
  methods: {
    atualizarValor
  },
  watch: {
    value,
    options
  }
};

function data() {
  return {
    selecionado: this.value
  };
}

function atributos() {
  const atributos = Object.assign({}, this.$attrs);

  if (atributos["selectedLabel"] == null) {
    atributos.selectedLabel = "";
  }

  if (atributos["closeOnSelect"] == null) {
    atributos.closeOnSelect = true;
  }

  if (atributos["selectLabel"] == null) {
    atributos.selectLabel = "";
  }

  if (atributos["deselectLabel"] == null) {
    atributos.deselectLabel = "";
  }

  if (atributos["placeholder"] == null) {
    atributos.placeholder = "Selecione";
  }

  if (atributos["tagPlaceholder"] == null) {
    atributos.tagPlaceholder = "Pressione enter para criar nova tag";
  }

  if (atributos["allowEmpty"] == null) {
    atributos.allowEmpty = false;
  }

  atributos.multiple = false;

  return atributos;
}

function temLimpar() {
  return this.limpar ? this.selecionado != null : false;
}

function atualizarValor(valor) {
  this.selecionado = valor;
  this.$emit("input", valor);
  this.$emit("change", valor);
}

function value() {
  this.selecionado = this.value;
}

function options(options) {
  if (options.length === 1 && this.autoSelect) {
    this.atualizarValor(options[0]);
    this.$emit("auto-select", options[0]);
  }
}
</script>
